import { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { usePedidos } from '../../../../contexts/Pedidos';
import { ModalDetalhePedido } from '../Modais/ModalDetalhePedido';
import { useHistory } from 'react-router-dom';
import { RowListaPedidos } from '../RowListaPedidos';
import { PaginationTable } from '../../../../themes/components/PaginationTable';
import { VscArrowSmallDown, VscArrowSmallUp } from "react-icons/vsc";
import moment from 'moment';
import { Typography } from "@material-ui/core";
import ReactLoading from 'react-loading';
import { ArrayPedidos, Pedido } from '../../interfaces';
import { FieldDropdown } from '../../../../themes/components/FieldDropdown';

export function TabelaListaPedidos() {
  const { pedidosBusca, setPedidosBusca, loadingBuscaPedidosConsulta } = usePedidos();
  const [showModalDetalhePed, setShowModalDetalhePedido] = useState<boolean>(false);
  const [selectedPedido, setSelectedPedido] = useState<number>(0);
  const [selectedCodEmp, setSelectedCodEmp] = useState<string>("");
  const history = useHistory();


  const [currentPage, setCurrentPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [pageCount, setPageCount] = useState<number>(0);
  const handleChangePage = (event: any, value: any) => { setCurrentPage(value) };
  const [pedidosPage, setPedidosPage] = useState<ArrayPedidos>([]);


  const [orderBy, setOrderBy] = useState("");
  const [revertOrderBy, setReveterOrderBy] = useState(true);
  const [ordenedPedidos, setOrdenedPedidos] = useState<ArrayPedidos>([]);

  const [estoque, setEstoque] = useState("Todos");
  const [iEstoque, setIEstoque] = useState("0");

  const optEstoque = [
    { "cod": "0", "nome": "Todos" },
    { "cod": "2", "nome": "GA" },
    { "cod": "4", "nome": "AB" }
  ];

  //Define a seta de ordenação que vai aparecer o lado do nome da coluna
  function showOrderByIcon(option: string) {
    switch (option) {
      case "pedido":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "cliente":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "estoque":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "data_emissao":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "data_entrega":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "qtd_original":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "valor_original":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      case "situacao":
        if (orderBy === option) {
          if (revertOrderBy) {
            return <VscArrowSmallDown size={20} />
          } else {
            return <VscArrowSmallUp size={20} />
          }
        } else {
          return <></>
        }
      default:
        return <></>
    }
  }

  //Mostrar modal do pedido
  const handleModal = (numPed: number, codEmp: string) => {
    setShowModalDetalhePedido(true);
    setSelectedPedido(numPed);
    setSelectedCodEmp(codEmp);
  }

  useEffect(() => {
    if (pedidosBusca instanceof Array)
      setOrdenedPedidos(pedidosBusca);
  }, [pedidosBusca])

  // This effect calculate the page number on filtered results
  useEffect(() => {
    if (ordenedPedidos instanceof Array)
      setPageCount(Math.ceil(ordenedPedidos.length / perPage));
  }, [perPage, ordenedPedidos]);

  // This effect apply the filtered caracters on products and set an array only with matched results
  // Whenever have change in filtered the current page is set to 0, the initial page 
  useEffect(() => {
    if (ordenedPedidos instanceof Array) {
      let tempPedidos = [...ordenedPedidos];

      if (revertOrderBy) {
        switch (orderBy) {
          case "pedido":
            tempPedidos.sort(function (a, b) {
              let keyA = parseInt(a.numPed), keyB = parseInt(b.numPed);
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break;
          case "cliente":
            tempPedidos.sort(function (a, b) {
              let keyA = parseInt(a.nomCli), keyB = parseInt(b.nomCli);
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break;
          case "estoque":
            tempPedidos.sort(function (a, b) {
              let keyA = parseInt(a.codEmp), keyB = parseInt(b.codEmp);
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break;
          case "data_emissao":
            tempPedidos.sort(function (a, b) {
              let keyA = moment(a.datEmi, "DD/MM/YYYY");
              let keyB = moment(b.datEmi, "DD/MM/YYYY");
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break
          case "data_entrega":
            tempPedidos.sort(function (a, b) {
              let keyA = moment(a.datPrv, "DD/MM/YYYY");
              let keyB = moment(b.datPrv, "DD/MM/YYYY");
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break
          case "qtd_original":
            tempPedidos.sort(function (a, b) {
              let keyA = parseFloat(a.qtdOri), keyB = parseFloat(b.qtdOri);
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break;
          case "valor_original":
            tempPedidos.sort(function (a, b) {
              let keyA = parseFloat(a.vlrOri), keyB = parseFloat(b.vlrOri);
              // Compare the 2 dates
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
            break;
          default:
            break;
        }
      } else {

        switch (orderBy) {
          case "pedido":
            tempPedidos.sort(function (a, b) {
              let keyA = parseInt(a.numPed), keyB = parseInt(b.numPed);
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break;
          case "cliente":
            tempPedidos.sort(function (a, b) {
              let keyA = parseInt(a.nomCli), keyB = parseInt(b.nomCli);
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break;
          case "estoque":
            tempPedidos.sort(function (a, b) {
              let keyA = parseInt(a.codEmp), keyB = parseInt(b.codEmp);
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break;
          case "data_emissao":
            tempPedidos.sort(function (a, b) {
              let keyA = moment(a.datEmi, "DD/MM/YYYY");
              let keyB = moment(b.datEmi, "DD/MM/YYYY");
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break
          case "data_entrega":
            tempPedidos.sort(function (a, b) {
              let keyA = moment(a.datPrv, "DD/MM/YYYY");
              let keyB = moment(b.datPrv, "DD/MM/YYYY");
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break
          case "qtd_original":
            tempPedidos.sort(function (a, b) {
              let keyA = parseFloat(a.qtdOri), keyB = parseFloat(b.qtdOri);
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break;
          case "valor_original":
            tempPedidos.sort(function (a, b) {
              let keyA = parseFloat(a.vlrOri), keyB = parseFloat(b.vlrOri);
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            break;
          default:
            break;
        }
      }
      setCurrentPage(1);
      setOrdenedPedidos(tempPedidos);
    }
  }, [orderBy, revertOrderBy]);


  // This effect push the filtered registers in current page
  useEffect(() => {
    if (ordenedPedidos instanceof Array) {
      let tempPedidos = [];
      let maxReg = currentPage * perPage;
      for (let index = (currentPage - 1) * perPage; index < maxReg && index < ordenedPedidos.length; index++) {
        if (ordenedPedidos[index] !== undefined)
          tempPedidos.push(ordenedPedidos[index]);
      }
      setPedidosPage(tempPedidos);
    }
  }, [ordenedPedidos, currentPage, perPage, orderBy, revertOrderBy, pedidosBusca]);

  useEffect(() => {
    if (pedidosBusca) {
      setOrderBy("");
      if (iEstoque == '0') {
        setOrdenedPedidos(pedidosBusca);
      } else {
        setOrdenedPedidos(pedidosBusca.filter((Item: Pedido) => Item.codEmp == iEstoque));
      }
    }

  }, [iEstoque]);

  function getCodEstoque(text: string) {
    let sit = "";
    optEstoque.forEach((opt) => {
      if (opt.nome === text) {
        sit = opt.cod;
      }
    })
    return sit;
  }

  function getEstoqueList() {
    let temp: string[] = []
    optEstoque.forEach((opt) => {
      temp.push(opt.nome)
    })
    return temp;
  }

  return (
    <div className="container-tabela-lista">

      <div className="form-group">
        <div className="" style={{ width: '98%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Typography style={{ marginRight: '0.5em', marginBottom: '0.5em', whiteSpace: 'nowrap' }}>Empresa</Typography>
          <div className={""} id="" style={{ width: '10em', height: '4em', border: 'none', borderRadius: '5px', fontSize: '0.9em' }}>

            <FieldDropdown
              value={estoque}
              id="seleciona-combobox-estoque"
              options={getEstoqueList()}
              label={(option: string) => option}
              onChange={(event, newInputValue) => {
                setEstoque(newInputValue);
                setIEstoque(getCodEstoque(newInputValue));
              }}
            />
          </div>
        </div>
      </div>

      {loadingBuscaPedidosConsulta ? <div className="loading-table-list-pedidos"><ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} /></div>
        :
        <div className="tabela-paginacao-area">
          <TableContainer component={Paper} className={"root-tabela-lista-pedidos"}>
            <Table stickyHeader aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("pedido") }}>{showOrderByIcon("pedido")}Pedido</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("cliente") }} align="left">{showOrderByIcon("cliente")}Cliente</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("estoque") }} align="left">{showOrderByIcon("estoque")}Empresa</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("data_emissao") }} align="center">{showOrderByIcon("data_emissao")}Data Emissão</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("data_entrega") }} align="center">{showOrderByIcon("data_entrega")}Previsão Faturamento</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("situacao") }} align="center">{showOrderByIcon("situacao")}Situação</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("qtd_original") }} align="right">{showOrderByIcon("qtd_original")}Qtd. Original</TableCell>
                  <TableCell className="th-tabela-lista-pedidos" onClick={() => { setReveterOrderBy(revertOrderBy ? false : true); setOrderBy("valor_original") }} align="right">{showOrderByIcon("valor_original")}Valor Original</TableCell>
                  <TableCell align="right" />
                  <TableCell align="right" />
                </TableRow>
              </TableHead>
              <TableBody>
                {pedidosPage !== null && pedidosPage instanceof Array && pedidosPage.length > 0 ? pedidosPage.map((row, index) => (
                  <RowListaPedidos key={row.numPed}
                    row={row}
                    handleModal={handleModal}
                    history={history}
                    index={index}
                    estoque={iEstoque}
                  />
                )) : <TableRow><TableCell><Typography>Nenhum pedido encontrado.</Typography></TableCell></TableRow>}
                {pageCount > 1 && perPage - pedidosPage.length > 0 && (
                  <TableRow style={{ height: 63 * (perPage - pedidosPage.length) }} >
                    <TableCell colSpan={8} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <PaginationTable
            textSingle="Pedido"
            textPlural="Pedidos"
            arrayItens={ordenedPedidos}
            page={currentPage}
            countPages={pageCount}
            defaultPage={1}
            handleChange={handleChangePage}
            shape="round"
            setCurrentPage={setCurrentPage}
            setPerPage={setPerPage}
            optionsPerPage={[5, 10, 50]}
            perPage={perPage}
          />
        </div>
      }
      <ModalDetalhePedido showModal={showModalDetalhePed} numPed={selectedPedido} codEmp={selectedCodEmp} setShowModal={setShowModalDetalhePedido} />
    </div>
  );
}